import { render, staticRenderFns } from "./UpdateOrderDetails.vue?vue&type=template&id=63764a5a&scoped=true&"
import script from "./UpdateOrderDetails.vue?vue&type=script&lang=js&"
export * from "./UpdateOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOrderDetails.vue?vue&type=style&index=0&id=63764a5a&scoped=true&lang=css&"
import style1 from "./UpdateOrderDetails.vue?vue&type=style&index=1&id=63764a5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63764a5a",
  null
  
)

export default component.exports